import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Customers = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'customer_type', label: 'Type' },
    { key: 'city', label: 'City' },
    { key: 'contact_person', label: 'Contact Person' },
    { key: 'gstin', label: 'GSTIN' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'CUST001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Customer Name' },
    { 
      name: 'customer_type', 
      label: 'Customer Type', 
      type: 'select',
      options: [
        { value: 'HEAD_OFFICE', label: 'Head Office' },
        { value: 'BRANCH', label: 'Branch' },
        { value: 'DELIVERY_LOCATION', label: 'Delivery Location' },
      ]
    },
    { name: 'address', label: 'Address', type: 'textarea', fullWidth: true },
    { name: 'city', label: 'City', placeholder: 'City' },
    { name: 'state', label: 'State', placeholder: 'State' },
    { name: 'country', label: 'Country', placeholder: 'Country' },
    { name: 'pincode', label: 'Pincode', placeholder: 'Pincode' },
    { name: 'phone', label: 'Phone', placeholder: 'Phone Number' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'email@customer.com' },
    { name: 'contact_person', label: 'Contact Person', placeholder: 'Contact Name' },
    { name: 'contact_phone', label: 'Contact Phone', placeholder: 'Contact Phone' },
    { name: 'gstin', label: 'GSTIN', placeholder: 'GSTIN Number' },
    { name: 'pan', label: 'PAN', placeholder: 'PAN Number' },
    { name: 'credit_limit', label: 'Credit Limit', type: 'number', placeholder: '0.00' },
    { name: 'credit_days', label: 'Credit Days', type: 'number', placeholder: '30' },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Customers"
      endpoint="customers"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN', 'DESPATCH']}
    />
  );
};

export default Customers;
